import { GqlSettingsFormTemplateQuestionType } from "~/__generated__";

import { FormTemplateQuestionFormInputs } from "../components/FormTemplateQuestionForm";

export default function buildTypeObject(
    type: GqlSettingsFormTemplateQuestionType,
    formData: FormTemplateQuestionFormInputs,
    existingId?: string,
) {
    const id = existingId ?? crypto.randomUUID();
    switch (type.__typename) {
        case "GqlSettingsFormTemplateQuestionTypeText":
            return {
                id,
                type: "text" as const,
                multiline: formData.multiline ?? false,
            };
        case "GqlSettingsFormTemplateQuestionTypeAmount":
            return {
                id,
                type: "amount" as const,
            };
        case "GqlSettingsFormTemplateQuestionTypeRecording":
            return {
                id,
                type: "recording" as const,
            };
        case "GqlSettingsFormTemplateQuestionTypeSelect":
            return {
                id,
                type: "select" as const,
                options: formData.options?.map(option => ({ ...option, key: option.key ?? "" })),
            };
        case "GqlSettingsFormTemplateQuestionTypeDropdown":
            return {
                id,
                type: "dropdown" as const,
                options: formData.options?.map(option => ({ ...option, key: option.key ?? "" })),
            };
        case "GqlSettingsFormTemplateQuestionTypeDateTime":
            return {
                id,
                type: "dateTime" as const,
            };
    }
}
